import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import * as fromStore from '../store';
import { Observable, Subscription } from 'rxjs';
import { LoadJobStatusListRequest } from '../models';
import { jobStates } from '../models';

@Component({
  selector: 'app-job-status-summary-search',
  templateUrl: './job-status-summary-search.component.html'
})
export class JobStatusSummarySearchComponent {
  hasSubmitted: boolean;

  form: FormGroup;
  summarySearchState$: Observable<fromStore.SummarySearchState>;

  private _subscriptionJobStatus: Subscription;
  private _searchCriteria: LoadJobStatusListRequest;

  constructor(private _store: Store<fromStore.JobState>, private fb: FormBuilder, private router: Router) {}

  ngOnInit() {
    this.summarySearchState$ = this._store.pipe(select(fromStore.getJobStatusSummarySearchState));

    this._subscriptionJobStatus = this.summarySearchState$.subscribe(s => {
      this._searchCriteria = s.searchCriteria;
    });

    const defaultFromDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().slice(0, 16);
    const defaultToDate = new Date().toISOString().slice(0, 16);

    this.form = this.fb.group({
      fromDate: [this._searchCriteria.fromDate ?? defaultFromDate], // last 7 days
      toDate: [this._searchCriteria.toDate ?? defaultToDate],
      jobName: [this._searchCriteria.jobName ?? ''],
      state: [this._searchCriteria.state ?? null],
      sort: ['CreatedAt:Desc'],
      take: [15],
      skip: [0]
    });
  }

  onDestroy() {
    this._subscriptionJobStatus.unsubscribe();
  }

  /**
   * Submits the form and navigates to the credit report summary page with
   * the query parameters set from the form values.
   */
  onSearch() {
    if (this.form.invalid) return;

    // Our query we'll fill in later
    const summaryRequest: LoadJobStatusListRequest = {
      fromDate: null,
      toDate: null,
      jobName: null,
      state: null,
      skip: null,
      take: null,
      sort: null
    };

    Object.keys(this.form.controls).forEach(key => {
      const value = this.form.get(key).value;
      summaryRequest[key] = value;
    });
    this.hasSubmitted = true;

    this._store.dispatch(new fromStore.ExecuteJobStatusSearch(summaryRequest));
  }

  getJobStateName(state: number) {
    const jobState = jobStates.find(js => js.value === state);
    return jobState ? jobState.key : 'Unknown';
  }
}
